import { parkingPaymentHistoryPlaceHolderData } from '~/utils/placeholderData'

export default (payload) => {
    const { bearerToken } = payload

    const fetchParkingHistory = () => {
        const apiUrl = '/api/parking/consumer/history/parking-sessions'

        // Define header
        const headers = {
            Authorization: `Bearer ${bearerToken.value}`,
        }

        return $fetch(apiUrl, { headers })
    }

    return useFetchWithTanstackQuery({
        queryKey: ['parkingPaymentHistory', bearerToken.value],
        queryFn: fetchParkingHistory,
        storageType: null,
        preventFatalError: true, // Handle profile errors more specific
        options: {
            placeholderData: parkingPaymentHistoryPlaceHolderData,
            staleTime: 0,
            cacheTime: 0,
            enabled: !!bearerToken.value
        }
    })
}
